/**
 * 是否为外部链接
 * @param {*} path 【必填】需要校验的数据
 */
function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
   * 是否为字符串
   * @param {*} str 【必填】需要校验的数据
   */
function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
   * 是否为空
   * @param {*校验数据} str
   */
function isUndeFinedOrNullOrBlank(str) {
  return str === undefined || str == null || (typeof str === 'string' && str.trim() === '')
}

/**
   * 是否为数组
   * @param {*} arg 【必填】需要校验的数据
   */
function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
   * 校验url是否规范
   * @param {*} url 【必填】需要校验的url
   */
function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
   * 是否全为小写字母
   * @param {*} str 【必填】需要校验的数据
   */
function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
   * 是否全为大写字母
   * @param {*} str 【必填】需要校验的数据
   */
function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
   * 是否全为字母
   * @param {*} str 【必填】需要校验的数据
   */
function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
   * 邮箱校验
   * @param {*} email 【必填】需要校验的数据
   */
function validEmail(email) {
  const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
   * 手机号校验
   * @param {*} mobile 【必填】需要校验的数据
   */
function validMobile(mobile) {
  const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
  return reg.test(mobile)
}

/**
   * 电话号码校验
   * @param {*} phone 【必填】需要校验的数据
   */
function validPhone(phone) {
  const reg = /^(\d{3,4}-)?\d{7,8}$/// 座机和传真格式是一样的：区号-号码
  return reg.test(phone)
}

/**
   * 身份证号码校验
   * @param {*} idCard 【必填】需要校验的数据
   */
function validIdCard(idCard) {
  const reg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/
  return reg.test(idCard)
}
/**
 * 是否json对象
 * @param str
 * @returns {boolean}
 */
function isJson(str) {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str)
      if (typeof obj === 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  } else if (typeof str === 'object') {
    return true
  } else {
    return false
  }
}

function isDot(value) {
  const reg = /^(-|\+)?\d+\.\d*$/
  if(reg.test(value)) {
    const length = value.toString().split('.')[1].length
    return length
  }
  return reg.test(value)
}

// 判断密码强度
function validPassword(value = '', length = 8, max = Number.MAX_SAFE_INTEGER) {
  let level = 0
  const vLength = value.length
  const regList = [
      /\d/, // 数字
      /[A-Z]/, // 大写字母
      /[a-z]/, // 小写字母
      /[~!@ #$%^&*()_+`\-={}:";'<>?,.\/\[\]\|]/, // 特殊字符
  ]
  if(vLength >= length && vLength <= max) {
      level += 1
  }
  regList.forEach(v => {
      if(v.test(value)) {
          level += 1
      }
  })
  return level
}

export default {
  isExternal,
  isString,
  isArray,
  validURL,
  validLowerCase,
  validUpperCase,
  validAlphabets,
  validEmail,
  validMobile,
  validPhone,
  validIdCard,
  isUndeFinedOrNullOrBlank,
  isJson,
  isDot,
  validPassword
}
